import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Subheader from "../../sharedComponent/Subheader";
import { Carousel } from "react-responsive-carousel";
import pedigree from "../../assets/images/pedigreeImg.svg";
import CouponBadge from "../../assets/images/redCouponBadge.svg";
import heartBorder from "../../assets/images/heartBorder.svg";
import BlueHeart from "../../assets/images/blueFilledHeart.svg";
import plusIco from "../../assets/images/plusIcon.svg";
import minusIco from "../../assets/images/minusIcon.svg";
import dustbinImg from "../../assets/images/dustbinImg.svg";
import Star from "../../assets/images/Star.svg";
import dr_2 from "../../assets/images/biry.jpg";

import ProgressBar from "react-bootstrap/ProgressBar";
import Slider from "react-slick";
import Steps from "../../assets/images/footSteps.svg";
import { MenuSquare } from "lucide-react";
import veg_icon from "../../assets/images/icons/veg_icon.svg";
import nonveg_icon from "../../assets/images/icons/nonveg_icon.svg";
import ListComponent from "../../sharedComponent/ListComponent";
import ApiConfig from "../../api/ApiConfig";
import { getAddonDataArr } from "../../utils/AddonService";
import {
  GetWithAuth,
  PostWithAuth,
  postWithAuthCallWithErrorResponse,
} from "../../api/ApiServices";
import { AppContext } from "../../context/AppContext";
import { notifyError, notifySuccess } from "../../sharedComponent/notify";
import VariationModal from "../../utils/variationModal/VariationModal";

const PetShopDetails = ({
  categoryName,
  setMenuList,
  category_id,
  menuList,
  category_item,
  MenuCategoryList,
  onListItemClick,
  menuClick,
  setMenuClick,
}) => {

  const [heartClicked, setHeartClicked] = useState(false);
   const  [showVariationModal , setShowVariationModal] = useState(false)
  const [heartClick, setHeartClick] = useState(false);
  const [isLoadinAddToCart, setIsLoadinAddToCart] = useState(true);
  const [categoryImg, setCategoryImg] = useState(null);
  const { selectedStore , defaultImgs} = useContext(AppContext);
  const [cartCount, setcartCount] = useState(0);
  const [cate, setcate] = useState(false);
  const navigate = useNavigate();

function getCategoryById(categoryId, categories) {
  
  const cat=  categories.find(
    (category) => Number(category.category_id) == Number(categoryId)
  ) || null;

  setCategoryImg(cat?.category_image_url)
}


useEffect(()=>{
if (Number(localStorage.getItem("category_id")) && MenuCategoryList?.length > 0) {
  getCategoryById(Number(localStorage.getItem("category_id")) , MenuCategoryList);
}
},[Number(localStorage.getItem("category_id")), MenuCategoryList])
   const [variationData, setVariationData] = useState([]);
  
    const handleOpenVariationModal = (item) => {
      setVariationData(item);
      setShowVariationModal(true)
    }
    const handleCloseVariationModal = ()=>{
      setShowVariationModal(false);
    }
    
    const handleAddToCart = (item) => {
   
      if(item.item_allow_variation == 1 || item.item_allow_addon == 1) {
  
         handleOpenVariationModal(item)
         return ;
      }
    
      addToCart(item);
    };

      const handleAddToCartVariation = ( item , variationId) => {
       
  
    addToCart(item, variationId);
    setShowVariationModal(false);
  }


  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleMenuClick = () => {
    setMenuClick(!menuClick);
  };

  const changeQuantity = async (item) => {
    try {
      let addons = [];
      item?.cart_addons?.map((i) => {
        addons.push({
          cart_addon_id: i?.addon_cart_id,
          quantity: 1,
          addon_id: i?.addon_id,
        });
      });
      let requestBody = {
        cart_id: item?.cart_id,
        order_quantity: item?.cart_quantity + 1,
        addons: addons,
      };
      console.log("requestBody=>>", requestBody);
      console.log("item=>>", item);
      let res = await postWithAuthCallWithErrorResponse(
        `${ApiConfig?.UPDATE_CART}`,
        requestBody
      );

      if (res?.success) {
        notifySuccess(res?.json?.message);

        loadData();
        loadCart();
      }
    } catch (error) {
      notifyError(error?.json?.message);
    }
  };
  const addToCart = async (item , variationId = null) => {
    console.log("item", item);
    // {item?.item_allow_variation==1?parseFloat(item?.variations?.[0]?.variation_price)+parseFloat(item?.item_price):parseFloat(item?.item_price)}
    try {
      // let item_variation_id = item?.variations?.filter(
      //   (i) => i?.selected == true
      // )?.[0]?.item_variation_id;

      const   item_variation_id = item?.item_allow_variation == 1 ? variationId : null ;
    
      const loginData = localStorage.getItem("LOGIN_DATA");
      let requestBody = {
        item_id: item?.item_id,
        variation_id: item_variation_id ?? null,
    
        user_id: loginData.id,
        order_quantity: 1,
        addons: getAddonDataArr(item),
      };

      console.log("requestBody", requestBody);
      console.log("url", ApiConfig?.Add_TO_CART);
      // return

      if (
        item?.cart_quantity > 0 &&
        item?.cart_variation_id == requestBody?.variation_id
      ) {
        // alert('same')
        changeQuantity(item);
        return;
      }
      //   if (!isLoadinAddToCart) return;  check it
      setIsLoadinAddToCart(false);
      let res = await postWithAuthCallWithErrorResponse(
        `${ApiConfig?.Add_TO_CART}`,
        JSON.stringify(requestBody)
      );
      console.log("res", JSON.stringify(res));

      if (res?.json?.success) {
        notifySuccess(res?.json?.message);

        loadData();

        loadCart();
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error?.json?.message);
    }
  };

  const loadData = async () => {
    await loadMenu();
  };

  const [loadCartVariationIdArray, setLoadCartVariationIdArray] = useState([]);
  const loadCart = async () => {
    try {
      let res = await GetWithAuth(`${ApiConfig?.CART_LIST}`);
      console.log("resss", JSON?.stringify(res));
      if (res?.success) {
        let val = 0;
        res?.data?.map((i) => {
          val += i.order_quantity;
        });
        setcartCount(val);

        const variation_ids = res?.data?.map((item) => item.variation_id);
        setLoadCartVariationIdArray(variation_ids)

      
      }
    } catch (error) {
      //   dispatch(setCountCart({ cartCount: 0 }));
    }
  };

  console.log('taleen_variation_ids--', loadCartVariationIdArray)

  useEffect(() => {
    loadCart();
  }, []);
  const loadMenu = async () => {
    try {
      console.log(
        "url==>",
        `${ApiConfig?.GET_MENU}?restaurant_id=${selectedStore}&page_limit=9999&category=${category_id}`
      );
      let res = await GetWithAuth(
        `${ApiConfig?.GET_MENU}?restaurant_id=${selectedStore}&page_limit=9999&category=${category_id}`
      );
      setIsLoadinAddToCart(true);
      if (res?.success) {
        setMenuList([...res?.data]);
      }
    } catch (error) {
      setIsLoadinAddToCart(true);
      //   AlertDialogDanger(error?.message);
    }
  };

  const computeMenuItemDetails = (item) => {
 
    if (!item) return {};

    // 🧮 1. Find selected variation in cart
    const selected_cart_data = item?.variations?.find((v) =>
      item?.cart?.some(
        (c) =>
          c?.cart_item_id === item?.item_id &&
          c?.cart_variation_id === v?.item_variation_id
      )
    );
   

    // 🧮 2. Find matching cart data
    const cart_data = item?.cart?.find(
      (c) => c?.cart_item_id == item?.item_id
      // &&
      //   c?.cart_variation_id === selected_cart_data?.item_variation_id
    );
 

    // 🧮 3. Ensure one variation is marked selected if none selected
    const hasSelectedVariation = item?.variations?.some((v) => v?.selected);
    if (
      !selected_cart_data?.item_variation_id &&
      item?.variations?.length > 0 &&
      !hasSelectedVariation
    ) {
      item.variations[0].selected = true;
    }

    // 🧮 4. Combine variations and addons (for customization availability)
    const cartLen = [...(item?.variations || []), ...(item?.addons || [])];

    // 🧮 5. Calculate display price
    const basePrice = parseFloat(item?.item_price ?? 0);
    const variationPrice = parseFloat(
      selected_cart_data?.variation_price ??
        item?.variations?.[0]?.variation_price ??
        0
    );

    const itemPrice =
      item?.item_allow_variation === 1 ? basePrice + variationPrice : basePrice;

    // 🧮 6. Out of stock logic
    const outOfStock =
      item?.item_active === 0 ||
      item?.in_stock === 0 ||
      (item?.in_stock === 1 && item?.quantity === 0) ||
      (item?.item_allow_variation === 1 &&
        item?.in_stock === 1 &&
        item?.variations?.length === 0);

    return {
      ...item,
      selected_cart_data,
      cart_data,
      cartLen,
      itemPrice,
      outOfStock,
    };
  };

  const changeQuantityNew = async (item, val) => {
    try {
      let addons = [];
      item?.cart_addons?.map((i) => {
        addons.push({
          cart_addon_id: i?.addon_cart_id,
          quantity: 1,
          addon_id: i?.addon_id,
        });
      });
      let requestBody = {
        cart_id: item?.cart_id,
        order_quantity: val ? item?.cart_quantity + 1 : item?.cart_quantity - 1,
        addons: addons,
      };
      console.log("requestBody=>>", requestBody);
      console.log("item=>>", item);
      let res = await PostWithAuth(`${ApiConfig?.UPDATE_CART}`, requestBody);
      console.log("res", res);

      if (res?.success) {
        notifySuccess(res?.message);

        loadData();
        loadCart();
      }
    } catch (error) {
      notifyError(error?.json?.message);
    }
  };

  const deleteCartItem = async (item) => {
    try {
      let requestBody = {
        cart_id: item?.cart_id,
      };
      console.log("remove", requestBody);

      let res = await PostWithAuth(
        `${ApiConfig?.REMOVE_CART_ITEM}`,
        requestBody
      );
      console.log("res", res);
      if (res?.success || res?.json?.success) {
        notifySuccess(res?.message || res?.json?.message);
        loadData();
        loadCart();
      }
    } catch (error) {
      notifyError(error?.json?.message);
    }
  };

  const handleViewCartItems = () => {
    navigate('/Cart');
  }

function getVariationPrices(variations, ids) {
  return ids?.map(id => {
    const match = variations?.find(
      item => item.item_variation_id === id
    );
    return match ? match?.variation_price : false;
  });
}



  return (
    <>
      <div className="medicinesDetails" id="cx-main">
        {/* <Subheader category_item={category_item}  /> */}
        {/* Product Description */}
        <div className="ProductDescriptionmain">
          <div className="row">
            

            <div className="big-category-image-div margin-bottom-big">
              <div className="category-menu-button-div">
                <button onClick={handleMenuClick} className="button-main ">
                  Menu
                </button>
              </div>
              <div
                className={`list-component-display ${
                  !menuClick ? "display-none" : ""
                } `}
              >
                <ListComponent
                  MenuCategoryList={MenuCategoryList}
                  onListItemClick={onListItemClick}
                  demo={( defaultImgs?.category_image || dr_2)}
                />
              </div>
       <img
  className="big-category-image"
  src={
    !categoryImg || 
    categoryImg === "null"
      ? ( defaultImgs?.category_image || dr_2)
      : categoryImg
  }
  alt="img not found"
  onError={(e) => {
    e.target.onerror = null; // Prevent loop
    e.target.src = ( defaultImgs?.category_image || dr_2);
  }}
/>


            </div>
            <div className="col-md-12">
              <div className="CardsCarousel">
                <div className="carouselHeading">
                  <h2 className="headTxt">{categoryName}</h2>
                  {/* <img src={Steps} className='Steps' alt="" /> */}
                </div>

                <div
                  className="carosuelInside width-25---  "
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    gap: "16px",
                  }}
                >
                  {menuList?.length > 0 &&
                    menuList?.length < 5 &&
                    menuList.slice(0, 4)?.map((item) => {
                      const {
                        selected_cart_data,
                        cart_data,
                        cartLen,
                        itemPrice,
                        outOfStock,
                      } = computeMenuItemDetails(item);
                      return (
                        <div
                          className={`medicineCardsCarosel width-25  ${
                            item?.item_active == 0 ||
                            item?.in_stock == 0 ||
                            (item?.in_stock == 1 && item?.quantity == 0) ||
                            (item?.item_allow_variation === 1 &&
                              item?.in_stock == 1 &&
                              item?.variations?.length == 0)
                              ? "greyscale"
                              : ""
                          }`}
                          key={item.item_id}
                          id="custom-card-my"
                        >
                          <div className="innerContent">
                            <img
                              className="category-img"
                              height={180}
                              width={180}
                              src={
                                item.item_image_url === null
                                  ? ( defaultImgs?.item_image || dr_2)
                                  : item.item_image_url
                              }
                              onError={(e) => (e.target.src = ( defaultImgs?.item_image || dr_2))}
                              pedigree
                              alt="Image not found"
                            />

                            {/* <img onClick={() => setHeartClick(!heartClick)} src={heartClick ? heartBorder : BlueHeart} className='heartBor' alt="" /> */}
                            {/* <img src={CouponBadge} className='couponBadge' alt="" /> */}
                          </div>
                          <div className="detailsSec">
                            <label htmlFor="" className="headName">
                              {item.item_name}
                            </label>
                            {/* <label htmlFor="" className="flexStar">
                              <img src={Star} className="starImg" alt="" />
                              {item.avg_rating}
                            </label> */}
                          </div>
                          <div className="rateBox detailsSec">
                            <label htmlFor="" className="amntActive">
                              ₹ {item?.item_allow_variation == 1 ? (Number(item?.variations?.[0]?.variation_price ?? 0 )) + Number(item.item_price) : (item.item_price)}
                            </label>
                            <div>
                              <label
                                htmlFor=""
                                className="mutedTxt-- d-flex gap-1"
                              >
                                {item.attribute_name}{" "}
                                   {(item.attribute_name === "veg" || item.attribute_name === "non-veg" ) && (
                                <img
                                  width={24}
                                  height={24}
                                  src={
                                    item.attribute_name === "veg"
                                      ? veg_icon
                                      : item.attribute_name === "non-veg"
                                      ? nonveg_icon
                                      : ""
                                  }
                                />
                                   )}
                              </label>
                            </div>
                          </div>

                            {(item?.item_allow_variation == 1 || item?.item_allow_addon == 1)  ? (
                             <div className="text-center">
                                <p style={{margin: "0", fontSize:'14px' , color:'#006600' , fontStyle:'italic'}}>Customization available</p>
                                 </div>
                                 ): null}
                    
                          {cart_data?.cart_quantity > 0 ? (
                            <div className="d-flex justify-content-center">
                              <div className="button-main qntyBox-button">
                                <label
                                  onClick={() => {
                                    if (cart_data?.cart_quantity == 1) {
                                      deleteCartItem(cart_data);
                                    } else {
                                      changeQuantityNew(cart_data, false);
                                    }
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img src={minusIco} alt="-" />
                                </label>
                                <label htmlFor="" className="value">
                                  {cart_data?.cart_quantity}
                                </label>
                                <label
                                  onClick={() =>
                                    changeQuantityNew(cart_data, true)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <img src={plusIco} alt="+" />
                                </label>
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-center">
                              <button
                                // onClick={() => addToCart(item)}
                               onClick={() => handleAddToCart(item)}
                                className="button-main"
                              >
                                Add to cart
                              </button>
                            </div>
                          )}

                          {item?.item_active == 0 ||
                          item?.in_stock == 0 ||
                          (item?.in_stock == 1 && item?.quantity == 0) ||
                          (item?.item_allow_variation === 1 &&
                            item?.in_stock == 1 &&
                            item?.variations?.length == 0) ? (
                            <div className="out-of-stock-overlay">
                              <span className="out-of-stock-text">
                                Out of Stock
                              </span>
                            </div>
                          ) : null}
                        </div>
                      );
                    })}
                </div>

                {menuList?.length > 4 && (
                  <div className="carosuelInside">
                    <Slider
                      slidesToScroll={4}
                      speed={500}
                      infinite={true}
                      slidesToShow={4}
                      initialSlide={0}
                    >
                      {console.log("menuList--", menuList)}
                      {menuList?.length > 0 &&
                        menuList?.map((item) => {
                          const {
                            selected_cart_data,
                            cart_data,
                            cartLen,
                            itemPrice,
                            outOfStock,
                          } = computeMenuItemDetails(item);
                          return (
                            <div
                              className={`medicineCardsCarosel ${
                                item?.item_active == 0 ||
                                item?.in_stock == 0 ||
                                (item?.in_stock == 1 && item?.quantity == 0) ||
                                (item?.item_allow_variation === 1 &&
                                  item?.in_stock == 1 &&
                                  item?.variations?.length == 0)
                                  ? "greyscale"
                                  : ""
                              }`}
                              key={item.item_id}
                            >
                              <div className="innerContent">
                                <img
                                  className="category-img"
                                  height={180}
                                  width={180}
                                  src={
                                    item.item_image_url === null
                                      ? ( defaultImgs?.item_image || dr_2)
                                      : item.item_image_url
                                  }
                                  onError={(e) => (e.target.src = ( defaultImgs?.item_image || dr_2))}
                                  pedigree
                                  alt="Image not found"
                                />

                                {/* <img onClick={() => setHeartClick(!heartClick)} src={heartClick ? heartBorder : BlueHeart} className='heartBor' alt="" /> */}
                                {/* <img src={CouponBadge} className='couponBadge' alt="" /> */}
                              </div>
                              <div className="detailsSec">
                                <label htmlFor="" className="headName">
                                  {item.item_name}
                                </label>
                                {/* <label htmlFor="" className="flexStar">
                                  <img src={Star} className="starImg" alt="" />
                                  {item.avg_rating}
                                </label> */}
                              </div>
                              <div className="rateBox detailsSec">
                                <label htmlFor="" className="amntActive"> {/* taleeb */}
                                 
                           ₹ {
  (() => {
    if (item?.item_allow_variation !== 1) {
      return item.item_price;
    }

    const prices = getVariationPrices(
      item?.variations,
      loadCartVariationIdArray
    );

    // find first valid price
    const variationPrice = prices.find(price => price !== false);

    if (variationPrice) {
      return Number(variationPrice) + Number(item.item_price);
    }

    return (
      Number(item?.variations?.[0]?.variation_price ?? 0) +
      Number(item.item_price)
    );
  })()
}


   </label>
                                <div>
                                  <label
                                    htmlFor=""
                                    className="mutedTxt-- d-flex gap-1"
                                  >
                                    {item.attribute_name}{" "}
                                    {(item.attribute_name === "veg" || item.attribute_name === "non-veg" ) && (
                                    <img
                                      width={24}
                                      height={24}
                                      src={
                                        item.attribute_name === "veg"
                                          ? veg_icon
                                          : item.attribute_name === "non-veg"
                                          ? nonveg_icon
                                          : ""
                                      }
                                    />
                                    )}
                                  </label>
                                </div>
                              </div>

                                {(item?.item_allow_variation == 1 || item?.item_allow_addon == 1)  ? (
                             <div className="text-center">
                                <p style={{ margin: "0",fontSize:'14px' , color:'#006600' , fontStyle:'italic'}}>Customization available</p>
                                 </div>
                                 ) : null}
                         
                              {cart_data?.cart_quantity > 0 ? (
                                <div className="d-flex justify-content-center">
                                  <div className="button-main qntyBox-button">
                                    <label
                                      onClick={() => {
                                        if (cart_data?.cart_quantity == 1) {
                                          deleteCartItem(cart_data);
                                        } else {
                                          changeQuantityNew(cart_data, false);
                                        }
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img src={minusIco} alt="-" />
                                    </label>
                                    <label htmlFor="" className="value">
                                      {cart_data?.cart_quantity}
                                    </label>
                                    <label
                                      onClick={() =>
                                        changeQuantityNew(cart_data, true)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img src={plusIco} alt="+" />
                                    </label>
                                  </div>
                                </div>
                              ) : (
                                <div className="d-flex justify-content-center">
                                  <button
                                    // onClick={() => addToCart(item)}
                                    onClick={() => handleAddToCart(item)}
                                    className="button-main"
                                  >
                                    Add to cart 
                                  </button>
                                </div>
                              )}

                              {item?.item_active == 0 ||
                              item?.in_stock == 0 ||
                              (item?.in_stock == 1 && item?.quantity == 0) ||
                              (item?.item_allow_variation === 1 &&
                                item?.in_stock == 1 &&
                                item?.variations?.length == 0) ? (
                                <div className="out-of-stock-overlay">
                                  <span className="out-of-stock-text">
                                    Out of Stock
                                  </span>
                                </div>
                              ) : null}
                            </div>
                          );
                        })}
                     
                    </Slider>
                  </div>
                )}

                {menuList?.length < 1 && (
                  <div>
                    <p>No data found</p>
                  </div>
                )}
              </div>
            </div>
<div
  style={{
    position: "fixed",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 999,
    display: "flex",
    justifyContent: "center",
    width: "100%",
    pointerEvents: "none", // prevents blocking other areas
  }}
>
  <button
    style={{
      padding: "14px 28px",
      fontSize: "16px",
      borderRadius: "10px",
      fontWeight: "600",
      backgroundColor: "#f9bc03",
      border: "none",
      color: "#000000",
      boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
      minWidth: "240px",
      textAlign: "center",
      pointerEvents: "auto", // enables button click
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    onClick={handleViewCartItems}
  >
    {`View items (${cartCount})`}
  </button>
</div>




         
          </div>
        </div>
      </div>

      {/* <VariationModal
  showModal={showVariationModal}
  variations={variationData?.variations}
  onClose={handleCloseVariationModal}

    onAdd={(variationId) => {
    console.log("Selected:", variationId);
    
    handleAddToCartVariation(variationData ,variationId )
  }}
/> */}


<VariationModal
  showModal={showVariationModal}
  item={variationData}   // ⬅ full item: variations + addons
  onClose={handleCloseVariationModal}
  onAdd={(customizedItem, variationId) => {
    handleAddToCartVariation(customizedItem , variationId);
  }}
/>

    </>
  );
};

export default PetShopDetails;
